import { render, staticRenderFns } from "./SideBanners.vue?vue&type=template&id=2d7dfdc2"
import script from "./SideBanners.vue?vue&type=script&lang=js"
export * from "./SideBanners.vue?vue&type=script&lang=js"
import style0 from "./SideBanners.vue?vue&type=style&index=0&id=2d7dfdc2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports